module.exports = __webpack_public_path__ + "img/Weapon_270.644f114d.png";